import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export type WorkoutDeepLink = {
  url: string;
};

export const getWorkoutDeepLink = async (
  workoutId: number,
): Promise<WorkoutDeepLink> => {
  const token = auth.getToken();

  const response = await axios.post(
    getCreatorApiUrl(`/branch/generate`),
    {
      workoutId,
      type: 'workout',
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export const useGetWorkoutDeepLinkQuery = () =>
  useMutation({
    mutationFn: getWorkoutDeepLink,
  });
